export default {
    methods: {
        isHotelOwnerCreationRoute() {
            return this.$route.name === 'newHotel';
        }
    },
};
